import React from 'react';

const BasketRecommendationSection = () => {
    return (
        <div className='mb-24'></div>
    );
};

export default BasketRecommendationSection;
